/**
 * Ryan O'Dowd
 * 2025-01-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Dialog as PaperDialog,
} from 'react-native-paper';
import React from 'react';
import {
  ScrollView,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Content = (props: ContentProps & React.ComponentProps<typeof PaperDialog.Content>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <PaperDialog.Content
      {...props}
      style={[styles.container, props.style]}
    >{/* @TODO: make this keyboard avoiding as well */}
      {props.disableScroll
        ? props.children
        : (
          <ScrollView showsVerticalScrollIndicator={false}>
            {props.children}
          </ScrollView>
        )
      }
    </PaperDialog.Content>
  );
};

class ContentProps {
  disableScroll?: boolean;
};

export default Content;
